// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file common/common.proto (package common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/common.proto.
 */
export const file_common_common: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message common.Pagination
 */
export type Pagination = Message<"common.Pagination"> & {
  /**
   * @generated from field: optional int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: optional int32 size = 2;
   */
  size?: number;

  /**
   * @generated from field: optional int32 total = 3;
   */
  total?: number;
};

/**
 * Describes the message common.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema: GenMessage<Pagination> = /*@__PURE__*/
  messageDesc(file_common_common, 0);

/**
 * @generated from message common.Sort
 */
export type Sort = Message<"common.Sort"> & {
  /**
   * @generated from field: optional string field = 1;
   */
  field?: string;

  /**
   * @generated from field: optional bool desc = 2;
   */
  desc?: boolean;
};

/**
 * Describes the message common.Sort.
 * Use `create(SortSchema)` to create a new message.
 */
export const SortSchema: GenMessage<Sort> = /*@__PURE__*/
  messageDesc(file_common_common, 1);

/**
 * @generated from message common.DateTimeRange
 */
export type DateTimeRange = Message<"common.DateTimeRange"> & {
  /**
   * @generated from field: optional string from = 1;
   */
  from?: string;

  /**
   * @generated from field: optional string to = 2;
   */
  to?: string;
};

/**
 * Describes the message common.DateTimeRange.
 * Use `create(DateTimeRangeSchema)` to create a new message.
 */
export const DateTimeRangeSchema: GenMessage<DateTimeRange> = /*@__PURE__*/
  messageDesc(file_common_common, 2);

/**
 * @generated from message common.DecimalRange
 */
export type DecimalRange = Message<"common.DecimalRange"> & {
  /**
   * @generated from field: optional string min = 1;
   */
  min?: string;

  /**
   * @generated from field: optional string max = 2;
   */
  max?: string;
};

/**
 * Describes the message common.DecimalRange.
 * Use `create(DecimalRangeSchema)` to create a new message.
 */
export const DecimalRangeSchema: GenMessage<DecimalRange> = /*@__PURE__*/
  messageDesc(file_common_common, 3);

/**
 * @generated from message common.IntRange
 */
export type IntRange = Message<"common.IntRange"> & {
  /**
   * @generated from field: optional int32 min = 1;
   */
  min?: number;

  /**
   * @generated from field: optional int32 max = 2;
   */
  max?: number;
};

/**
 * Describes the message common.IntRange.
 * Use `create(IntRangeSchema)` to create a new message.
 */
export const IntRangeSchema: GenMessage<IntRange> = /*@__PURE__*/
  messageDesc(file_common_common, 4);

/**
 * @generated from message common.CountryMessage
 */
export type CountryMessage = Message<"common.CountryMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string alpha2 = 2;
   */
  alpha2: string;

  /**
   * @generated from field: string alpha3 = 3;
   */
  alpha3: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: bool is_enabled = 5;
   */
  isEnabled: boolean;

  /**
   * @generated from field: bool is_allowed = 6;
   */
  isAllowed: boolean;

  /**
   * @generated from field: map<string, string> translations = 7;
   */
  translations: { [key: string]: string };
};

/**
 * Describes the message common.CountryMessage.
 * Use `create(CountryMessageSchema)` to create a new message.
 */
export const CountryMessageSchema: GenMessage<CountryMessage> = /*@__PURE__*/
  messageDesc(file_common_common, 5);

/**
 * @generated from message common.CountryPublicMessage
 */
export type CountryPublicMessage = Message<"common.CountryPublicMessage"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message common.CountryPublicMessage.
 * Use `create(CountryPublicMessageSchema)` to create a new message.
 */
export const CountryPublicMessageSchema: GenMessage<CountryPublicMessage> = /*@__PURE__*/
  messageDesc(file_common_common, 6);

/**
 * @generated from enum common.HealthStatus
 */
export enum HealthStatus {
  /**
   * @generated from enum value: HEALTH_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: HEALTH_STATUS_HEALTHY = 1;
   */
  HEALTHY = 1,

  /**
   * @generated from enum value: HEALTH_STATUS_UNHEALTHY = 2;
   */
  UNHEALTHY = 2,

  /**
   * @generated from enum value: HEALTH_STATUS_DISABLED = 3;
   */
  DISABLED = 3,
}

/**
 * Describes the enum common.HealthStatus.
 */
export const HealthStatusSchema: GenEnum<HealthStatus> = /*@__PURE__*/
  enumDesc(file_common_common, 0);

/**
 * @generated from enum common.LogLevel
 */
export enum LogLevel {
  /**
   * @generated from enum value: LOG_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOG_LEVEL_TRACE = 1;
   */
  TRACE = 1,

  /**
   * @generated from enum value: LOG_LEVEL_DEBUG = 2;
   */
  DEBUG = 2,

  /**
   * @generated from enum value: LOG_LEVEL_INFO = 3;
   */
  INFO = 3,

  /**
   * @generated from enum value: LOG_LEVEL_WARNING = 4;
   */
  WARNING = 4,

  /**
   * @generated from enum value: LOG_LEVEL_ERROR = 5;
   */
  ERROR = 5,

  /**
   * @generated from enum value: LOG_LEVEL_CRITICAL = 6;
   */
  CRITICAL = 6,
}

/**
 * Describes the enum common.LogLevel.
 */
export const LogLevelSchema: GenEnum<LogLevel> = /*@__PURE__*/
  enumDesc(file_common_common, 1);

/**
 * @generated from enum common.Environment
 */
export enum Environment {
  /**
   * @generated from enum value: ENVIRONMENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ENVIRONMENT_DEVELOPMENT = 1;
   */
  DEVELOPMENT = 1,

  /**
   * @generated from enum value: ENVIRONMENT_PRODUCTION = 2;
   */
  PRODUCTION = 2,

  /**
   * @generated from enum value: ENVIRONMENT_LOCAL = 3;
   */
  LOCAL = 3,

  /**
   * @generated from enum value: ENVIRONMENT_TESTING = 4;
   */
  TESTING = 4,
}

/**
 * Describes the enum common.Environment.
 */
export const EnvironmentSchema: GenEnum<Environment> = /*@__PURE__*/
  enumDesc(file_common_common, 2);

/**
 * @generated from enum common.SortDirection
 */
export enum SortDirection {
  /**
   * @generated from enum value: SORT_DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SORT_DIRECTION_ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: SORT_DIRECTION_DESC = 2;
   */
  DESC = 2,
}

/**
 * Describes the enum common.SortDirection.
 */
export const SortDirectionSchema: GenEnum<SortDirection> = /*@__PURE__*/
  enumDesc(file_common_common, 3);

/**
 * @generated from enum common.LanguageCode
 */
export enum LanguageCode {
  /**
   * @generated from enum value: LANGUAGE_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LANGUAGE_CODE_EN = 1;
   */
  EN = 1,

  /**
   * @generated from enum value: LANGUAGE_CODE_RU = 2;
   */
  RU = 2,

  /**
   * @generated from enum value: LANGUAGE_CODE_UA = 3;
   */
  UA = 3,

  /**
   * @generated from enum value: LANGUAGE_CODE_KZ = 4;
   */
  KZ = 4,
}

/**
 * Describes the enum common.LanguageCode.
 */
export const LanguageCodeSchema: GenEnum<LanguageCode> = /*@__PURE__*/
  enumDesc(file_common_common, 4);

/**
 * @generated from enum common.Theme
 */
export enum Theme {
  /**
   * @generated from enum value: THEME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: THEME_LIGHT = 1;
   */
  LIGHT = 1,

  /**
   * @generated from enum value: THEME_DARK = 2;
   */
  DARK = 2,
}

/**
 * Describes the enum common.Theme.
 */
export const ThemeSchema: GenEnum<Theme> = /*@__PURE__*/
  enumDesc(file_common_common, 5);

/**
 * @generated from enum common.AppType
 */
export enum AppType {
  /**
   * @generated from enum value: APP_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: APP_TYPE_CLIENT = 1;
   */
  CLIENT = 1,

  /**
   * @generated from enum value: APP_TYPE_ADMIN = 2;
   */
  ADMIN = 2,

  /**
   * @generated from enum value: APP_TYPE_PARTNER = 3;
   */
  PARTNER = 3,
}

/**
 * Describes the enum common.AppType.
 */
export const AppTypeSchema: GenEnum<AppType> = /*@__PURE__*/
  enumDesc(file_common_common, 6);

